import { render } from "./Callouts.vue?vue&type=template&id=1ae802a2"
import script from "./Callouts.vue?vue&type=script&lang=js"
export * from "./Callouts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__